'use strict'

export default (mockAxios) => {
  // 取得
  mockAxios.onGet(`/nisfa-integration`).reply(200, {
    'success': true,
    'data': {
      'enable': '1',
      'url': 'http://xxxxxxx',
      'basic_id': 'basic',
      'basic_pass': '***************',
      'proxy_host': 'http://proxy.com/xxx/xxx',
      'proxy_port': '9090',
      'proxy_user_id': 'proxy_user',
      'proxy_pass': '***************'
    }
  })

  // 更新
  mockAxios.onPut(`/nisfa-integration`).reply(200, {
    'success': true,
    'data': []
  })

  // NISFA連携先へ接続テストを行います。
  mockAxios.onPost(`/nisfa-integration/test`).reply(200, {
    'success': true,
    'message': ''
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/nisfaIntegrationRepositoryMock.js